import validator from 'vee-validate';
let Validator = validator.Validator;
const config = {
  fieldsBagName: 'fieldsBags',
  events: 'blur'
};
//验证邮箱
Validator.extend('emailExg', {
  getMessage: field => "Please enter the right email",
  validate: value => /^\s*([A-Za-z0-9_-]+(\.\w+)*@([\w-]+\.)+\w{2,5})\s*$/.test(value)
});

//验证手机号
Validator.extend('phone', {
  getMessage: field => "Please enter the correct mobile number",
  validate: value => /^[0-9]\d{0,}$/.test(value)
});
//验证账号密码
Validator.extend('passwordLength', {
  getMessage: field => "Passwords must be between 12 and 32 characters long.",
  validate: value => value.length > 11 && value.length < 33
});
Validator.extend('integrationPasswordLength', {
  getMessage: field => "Minimum password length of 8 characters",
  validate: value => value.length > 7
});
Validator.extend('passwordNorm', {
  getMessage: field => "The password must contain at least one uppercase letter, lowercase letter, number and special symbol each.",
  validate: value => /^(?![a-zA-Z0-9_]+$)(?![a-zA-Z\W_]+$)(?![a-z0-9\W_]+$)(?![A-Z0-9\W_]+$)/.test(value)
});
//包含数字，小写字母，大写字母, 特殊字符任意三种
Validator.extend('passwordRule', {
  getMessage: field => "The password must contain at least one uppercase letter, lowercase letter, number, and special symbol. At least three of these criteria must be met.",
  validate: value => {
    const hasNumber = /[0-9]/.test(value);
    const hasLowerCase = /[a-z]/.test(value);
    const hasUpperCase = /[A-Z]/.test(value);
    const hasSpecialChar = /[^a-zA-Z0-9]/.test(value); // 匹配任何非字母和非数字的字符

    // 计算满足条件的数量
    const criteriaMet = [hasNumber, hasLowerCase, hasUpperCase, hasSpecialChar].filter(Boolean).length;
    return criteriaMet >= 3;
  }
});
// 验证PIN
Validator.extend('pinLength', {
  getMessage: field => "PIN must be " + window.eventBus.ApiService.pinSettingInfo.maxLength + " digits.",
  validate: value => value.length === window.eventBus.ApiService.pinSettingInfo.maxLength
});
Validator.extend('required', {
  getMessage: (field) => {
    return field + " can not be empty";
  },
  validate: value => {
    return value || value === 0;
  }
});
Validator.extend('ip', {
  getMessage: (field) => {
    return 'The ' + field + " field must be a valid ip address";
  },
  validate: value => {
    return /^((1[0-9][0-9]\.)|(2[0-4][0-9]\.)|(25[0-5]\.)|([1-9][0-9]\.)|([0-9]\.)){3}((1[0-9][0-9])|(2[0-4][0-9])|(25[0-5])|([1-9][0-9])|([0-9]))$/.test(value);
  }
});
// 验证不能为0，正整数
Validator.extend('positiveInteger', {
  getMessage: (field) => {
    return field + " must be a positive integer and cannot be 0";
  },
  validate: value => {
    return /^[1-9]\d*$/.test(value);
  }
});
export default {
  validator: validator,
  config: config
};



//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/js/validateConfig.js
// module id = null
// module chunks = 